export default __webpack_public_path__ + "static/media/note.3812b441.png";